export const ListQueryKey = 'partRequests';
export const DetailQueryKey = 'partRequest';
export const Urls = {
  selectUrl: '/partyRequest/list',
  updateUrl: '/partyRequest/update',
  deleteUrl: '/partyRequest/delete',
  createUrl: '/partyRequest/create',
  detailUrl: '/partyRequest/info'
};